export default {"src":"/_next/static/media/logowtbg.6ee9b84c.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};